import { Overlays } from './overlays.js';

import {xCore} from './core';
import { URN as NSURN } from './utils/urn';
import { Map as Module_Map } from './map';
import { NSObjDetails } from './obj_details';
import { NSFunctions } from './utils/functions';

import TileLayer from 'ol/layer/Tile';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';

import {OSM} from 'ol/source';

import { get as getProjection } from 'ol/proj';
import { getTopLeft, getWidth } from 'ol/extent';
import { unByKey } from 'ol/Observable';


import TileWMS from 'ol/source/TileWMS';
import { getCacheKeyForTileKey } from 'ol/tilecoord.js';
import { NSObjectMultipleSelect } from './obj_multiple_select.js';


export let OverlaysWMTS = {};

let o_struct_overlays;

OverlaysWMTS.init = function (o_struct_overlays_in) 
{

    o_struct_overlays = o_struct_overlays_in;
}


OverlaysWMTS.f_add_wmts_layer = function (tree_node) 
{
    var map = Module_Map.f_get_map();

    let s_geoserver_layer_name = f_get_geoserver_layer_name(tree_node);

    var projection = getProjection('EPSG:3857');
    var projectionExtent = projection.getExtent();
    var size = getWidth(projectionExtent) / 256;
    var resolutions = new Array(14);
    var matrixIds = new Array(14);
    var s_tile_matrix_set_id = 'EPSG:900913'; //'EPSG:3857';
    let newZoom = map.getView().getZoom();
    let centroid = tree_node.centroid;
    let centroid_max_zoom = tree_node.centroid_max_zoom;
    //let s_wmts_style = ''; // s_geoserver_layer_name + '_centroid_style'; ;// 'GeoCascais:' + s_geoserver_layer_name + '_centroid_style'; //
    let s_wmts_style = f_get_wmts_style(newZoom, centroid, centroid_max_zoom, s_geoserver_layer_name)
    for (var z = 0; z < 24; ++z) 
    {
        // generate resolutions and matrixIds arrays for this WMTS
        resolutions[z] = size / Math.pow(2, z);
        matrixIds[z] = s_tile_matrix_set_id + ':' + z;
    }

    var o_wmts_tile_grid = new WMTSTileGrid(
        {
            origin: getTopLeft(projectionExtent),
            resolutions: resolutions,
            matrixIds: matrixIds,
        }
    );


    let s_guid = NSFunctions.guidGenerator();
    let s_cache_prevention_param = "&cache_prevention_param="+s_guid;

    let s_layer_name = 'GeoCascais:' + s_geoserver_layer_name;  //'GeoCascais:arvores',
    let s_url_wmts = xCore.application.endpoints.ogc + '/gwc/service/wmts?Version=1.0.0';
    s_url_wmts += s_cache_prevention_param;

    let o_wmts_source_default_options = 
    {
        /*
        attributions:
        'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
        'services/Demographics/USA_Population_Density/MapServer/">Olá! Olé! Testando </a>',
        */
        url: s_url_wmts,
        layer: s_layer_name,
        matrixSet: s_tile_matrix_set_id,
        format: 'image/png',
        projection: projection,
        tileGrid: o_wmts_tile_grid,
        style: s_wmts_style,
        wrapX: true,
    };

    var o_wmts_layer = new TileLayer({
        //opacity: 0.7,
        source: new WMTS( o_wmts_source_default_options ),
    });


    let s_url_wms = xCore.application.endpoints.ogc + '/GeoCascais/wms?&srs=EPSG%3A3857&styles=&format=image%2Fpng';
    let s_wms_src_param_layers = 'GeoCascais:' + s_geoserver_layer_name; //'GeoCascais:arvores';

    let wmsSource = new TileWMS({
        url: s_url_wms,
        params: {
            'LAYERS': s_wms_src_param_layers,
            'TILED': true,
            //'WIDTH': 512, 'HEIGHT': 512
            //,'VERSION': '1.1.0'
        },
        serverType: 'geoserver',
        crossOrigin: 'anonymous',
    });

    let o_wms_layer_selection = new TileLayer({
        source: wmsSource,
    });

    //map.addLayer(o_wms_layer_selection); //not suposed to be added to map

    
    //adding info to Overlays Struct
    let overlay_wmts = new Overlays.objs.OverlayWMTS({ tree_node: tree_node });
    overlay_wmts.o_wmts_layer = o_wmts_layer;
    overlay_wmts.o_wms_layer_selection = o_wms_layer_selection;

    o_struct_overlays.f_add_wmts_overlay(overlay_wmts);

    let map_moveend_listener_key = map.on('moveend', function (evt) {
        f_on_map_move_end(evt, overlay_wmts);
    });
    overlay_wmts.map_moveend_listener_key = map_moveend_listener_key;
    overlay_wmts.o_wmts_source_default_options = o_wmts_source_default_options;
    


    map.addLayer(o_wmts_layer);



}

let f_on_map_move_end = function(evt, overlay_wmts) {
    //let map = NSModule_Map_.f_get_map();
    const map = evt.map;
    /*
    const extent = map.getView().calculateExtent(map.getSize());
    console.log('extent: ');
    console.log(extent);
    */
    let newZoom = map.getView().getZoom();
    /*
    tree_node:
    {
        centroid: "true" || maybe || false
        centroid_max_zoom: int (ex: 14)
    }
    */
   let tree_node = overlay_wmts.tree_node;
   let centroid = tree_node.centroid;
   let centroid_max_zoom = tree_node.centroid_max_zoom;
   if (centroid == "maybe")
   {
        let map_zoom_change_previous_value = overlay_wmts.map_zoom_change_previous_value;

        let b_map_layer_source_stays_the_same = (map_zoom_change_previous_value != null
            && (
                (newZoom >= centroid_max_zoom && map_zoom_change_previous_value >= centroid_max_zoom)
                || (newZoom < centroid_max_zoom && map_zoom_change_previous_value < centroid_max_zoom))
            );

        if( b_map_layer_source_stays_the_same )
        {       // source stays the same
        }
        else    //change layer source - switch beteeen "centroid" and "default"
        {
            let s_geoserver_layer_name = f_get_geoserver_layer_name(tree_node);
            let s_wmts_style = f_get_wmts_style(newZoom, centroid, centroid_max_zoom, s_geoserver_layer_name)
            f_reset_wmts_layer_source(s_wmts_style, overlay_wmts);

        }
        overlay_wmts.map_zoom_change_previous_value = newZoom;

   }
   else //if (centroid == "false" || NULL)
   {
    //do nothing
   }


};

let f_get_geoserver_layer_name = function (tree_node)
{
    let a_urn_info = NSURN.f_get_urn_info(tree_node.urn);
    let s_urn_table = a_urn_info[2];
    let s_geoserver_layer_name = ( tree_node.geo_server_layer_name != null &&  tree_node.geo_server_layer_name.length > 0 ) ? tree_node.geo_server_layer_name : s_urn_table;
    return s_geoserver_layer_name; 
};

let f_get_wmts_style = function (zoom, centroid, centroid_max_zoom, s_geoserver_layer_name)
{
    const s_CONST_GEOSERVER_LAYER_STYLE_SUFIX = "_centroid_style";
    if (centroid == "true")
    {
        return s_geoserver_layer_name + s_CONST_GEOSERVER_LAYER_STYLE_SUFIX;
    }
    else if (centroid == "maybe")
    {
        if(zoom <= centroid_max_zoom)
        {
            return s_geoserver_layer_name + s_CONST_GEOSERVER_LAYER_STYLE_SUFIX;
        }
        else
        {
            return '';
        }
    }
    else //if (centroid == "false" || NULL)
    {
        return '';
    }

};

let f_reset_wmts_layer_source = function(s_wmts_style, overlay_wmts)
{
    let o_wmts_layer = overlay_wmts.o_wmts_layer;
    let o_wmts_source_default_options = overlay_wmts.o_wmts_source_default_options;
    o_wmts_source_default_options.style = s_wmts_style;

    let o_wmts_source = new WMTS( o_wmts_source_default_options );

    o_wmts_layer.setSource(o_wmts_source);

}

//Remove:
OverlaysWMTS.f_remove_wmts_layer = function(tree_node)
{

  let overlay = o_struct_overlays.f_get_wmts_overlay(tree_node.id);
  let map = Module_Map.f_get_map();
  
  map.removeLayer(overlay.o_wmts_layer);
  map.removeLayer(overlay.o_wmsLayer_selection);

  unByKey(overlay.map_moveend_listener_key);

  o_struct_overlays.f_remove_wmts_overlay(tree_node.id);

}

OverlaysWMTS.f_get_base_map_layer = function(s_internal_name)
{

    //var map = Module_Map.f_get_map();

    let s_geoserver_layer_name = s_internal_name;

    var projection = getProjection('EPSG:3857'); //EPSG:3763
    var projectionExtent = projection.getExtent();
    var size = getWidth(projectionExtent) / 256;
    var resolutions = new Array(14);
    var matrixIds = new Array(14);
    var s_tile_matrix_set_id = 'EPSG:900913'; //'EPSG:3857';
    let s_wmts_style = ''; 
    for (var z = 0; z < 24; ++z) 
    {
        // generate resolutions and matrixIds arrays for this WMTS
        resolutions[z] = size / Math.pow(2, z);
        matrixIds[z] = s_tile_matrix_set_id + ':' + z;
    }

    var o_wmts_tile_grid = new WMTSTileGrid(
        {
            origin: getTopLeft(projectionExtent),
            resolutions: resolutions,
            matrixIds: matrixIds,
        }
    );

    let s_guid = NSFunctions.guidGenerator();
    let s_cache_prevention_param = "&cache_prevention_param="+s_guid;

    let s_layer_name = 'GeoCascais:' + s_geoserver_layer_name;  //'GeoCascais:ortos_2022',
    let s_url_wmts = xCore.application.endpoints.ogc + '/gwc/service/wmts?Version=1.0.0';
    s_url_wmts += s_cache_prevention_param;

    let o_wmts_source_default_options = 
    {
        /*
        attributions:
        'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
        'services/Demographics/USA_Population_Density/MapServer/">Olá! Olé! Testando </a>',
        */
        url: s_url_wmts,
        layer: s_layer_name,
        matrixSet: s_tile_matrix_set_id,
        format: 'image/png',
        projection: projection,
        tileGrid: o_wmts_tile_grid,
        style: s_wmts_style,
        wrapX: true,
    };

    let o_wmts_layer = new TileLayer({
        //opacity: 0.7,
        source: new WMTS( o_wmts_source_default_options ),
    });
    
    //map.addLayer(o_wmts_layer);

    return o_wmts_layer;
}

OverlaysWMTS.f_get_main_basemap_layer = function(s_close_distance_layer_internal_name, i_close_distance_min_zoom)
{

    let map = Module_Map.f_get_map();

    let s_geoserver_layer_name = s_close_distance_layer_internal_name;

    var projection = getProjection('EPSG:3857'); //EPSG:3763
    var projectionExtent = projection.getExtent();
    var size = getWidth(projectionExtent) / 256;
    var resolutions = new Array(14);
    var matrixIds = new Array(14);
    var s_tile_matrix_set_id = 'EPSG:900913'; //'EPSG:3857';
    let s_wmts_style = ''; 
    for (var z = 0; z < 24; ++z) 
    {
        // generate resolutions and matrixIds arrays for this WMTS
        resolutions[z] = size / Math.pow(2, z);
        matrixIds[z] = s_tile_matrix_set_id + ':' + z;
    }

    var o_wmts_tile_grid = new WMTSTileGrid(
        {
            origin: getTopLeft(projectionExtent),
            resolutions: resolutions,
            matrixIds: matrixIds,
        }
    );

    let s_guid = NSFunctions.guidGenerator();
    let s_cache_prevention_param = "&cache_prevention_param="+s_guid;

    let s_layer_name = 'GeoCascais:' + s_geoserver_layer_name;  //'GeoCascais:ortos_2022',
    let s_url_wmts = xCore.application.endpoints.ogc + '/gwc/service/wmts?Version=1.0.0';
    s_url_wmts += s_cache_prevention_param;

    let o_wmts_source_default_options = 
    {
        /*
        attributions:
        'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
        'services/Demographics/USA_Population_Density/MapServer/">Olá! Olé! Testando </a>',
        */
        url: s_url_wmts,
        layer: s_layer_name,
        matrixSet: s_tile_matrix_set_id,
        format: 'image/png',
        projection: projection,
        tileGrid: o_wmts_tile_grid,
        style: s_wmts_style,
        wrapX: true,
    };

    let tile_source_close_distance = new WMTS( o_wmts_source_default_options );
    let tile_source_far_distance = new OSM();

    let o_wmts_layer = new TileLayer({
        //opacity: 0.7,
        source: tile_source_close_distance,
    });
    
    //map.addLayer(o_wmts_layer);


    //creatinng MAINBasemapWMTS object for data storing
    let main_basemap_wmts = new OverlaysWMTS.objs.MAINBasemapWMTS();
    main_basemap_wmts.o_wmts_layer = o_wmts_layer;
    main_basemap_wmts.i_close_distance_min_zoom = i_close_distance_min_zoom;


    let map_moveend_listener_key = map.on('moveend', function (evt) {
        f_on_main_basemap_move_end(evt, main_basemap_wmts);
    });
    main_basemap_wmts.map_moveend_listener_key = map_moveend_listener_key;
    main_basemap_wmts.o_wmts_source_default_options = o_wmts_source_default_options;
    main_basemap_wmts.tile_source_close_distance = tile_source_close_distance;
    main_basemap_wmts.tile_source_far_distance = tile_source_far_distance;






    return o_wmts_layer;
}

let f_on_main_basemap_move_end = function(evt, main_basemap_wmts) {
    //let map = NSModule_Map_.f_get_map();
    const map = evt.map;
    /*
    const extent = map.getView().calculateExtent(map.getSize());
    console.log('extent: ');
    console.log(extent);
    */
    let newZoom = map.getView().getZoom();

    let i_close_distance_min_zoom = main_basemap_wmts.i_close_distance_min_zoom;

    let map_zoom_change_previous_value = main_basemap_wmts.map_zoom_change_previous_value;

    let b_map_layer_source_stays_the_same = (map_zoom_change_previous_value != null
        && (
            (newZoom >= i_close_distance_min_zoom && map_zoom_change_previous_value >= i_close_distance_min_zoom)
            || (newZoom < i_close_distance_min_zoom && map_zoom_change_previous_value < i_close_distance_min_zoom))
        );

    if( b_map_layer_source_stays_the_same )
    {       // source stays the same
    }
    else    //change layer source - switch beteeen "centroid" and "default"
    {
        f_reset_main_basemap_layer_source( main_basemap_wmts, newZoom );
    }
    main_basemap_wmts.map_zoom_change_previous_value = newZoom;

}

let f_reset_main_basemap_layer_source = function(main_basemap_wmts, i_new_map_zoom)
{
    
    let i_close_distance_min_zoom = main_basemap_wmts.i_close_distance_min_zoom;

    let new_layer_source = ( i_new_map_zoom >= i_close_distance_min_zoom)? 
        main_basemap_wmts.tile_source_close_distance
        : main_basemap_wmts.tile_source_far_distance;

    let o_wmts_layer = main_basemap_wmts.o_wmts_layer;
    o_wmts_layer.setSource(new_layer_source);
}


var objs = {};

/*
    
*/
objs.MAINBasemapWMTS = function () 
{
  this.o_wmts_layer = null;                   // TileLayer from 'ol/layer/Tile';
  this.map_moveend_listener_key = null;
  this.map_zoom_change_previous_value = null;
  this.o_wmts_source_default_options = null;  // default options for source of TileLayer
  this.tile_source_far_distance = null;
  this.tile_source_close_distance = null;
  this.i_close_distance_min_zoom = null;
}


OverlaysWMTS.objs = objs;